module.exports = __webpack_public_path__ + "static/images/unfilled-rate.83aacd26e5e4ab54b35fc2f44d3cc498.svg";